import { ArrowDropDown, ArrowDropUp, Sort } from "@mui/icons-material"
import { Button } from "@mui/material"

export const SortButton = ({ sortProp, setSortProp, p }) => {

    const updateSortProp = () => {
        if (sortProp.sortparam !== p) {
            setSortProp({ sortparam: p, sortdirection: 1 })
        } else {
            setSortProp({ sortparam: p, sortdirection: -sortProp.sortdirection })
        }
    }

    if (sortProp?.sortparam === p) {
        if (sortProp.sortdirection > 0) {
            return <Button size="small" color="light" onClick={updateSortProp}><ArrowDropDown sx={{ fontSize: '1em', color: 'lightgreen' }} /></Button>

        } else {
            return <Button size="small" color="light" onClick={updateSortProp}><ArrowDropUp sx={{ fontSize: '1em', color: 'lightgreen' }} /></Button>
        }
    } else {
        return <Button size="small" color="light" onClick={updateSortProp}><Sort sx={{ fontSize: '0.8em', color: 'lightgrey' }} /></Button>
    }


}